/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';

export const DeclineButton = styled(Button)<any>`
  margin-right: ${gridSize()}px;
`;

export const DeclineErrorMessage = styled.div`
  margin-top: ${gridSize() / 4}px;
  margin-bottom: ${gridSize() * 3}px;
`;

export const ButtonContent = styled.div`
  position: relative;
`;

export const InnerButtonText = styled.span<{ isDisabled: boolean }>`
  ${props => (props.isDisabled ? 'visibility: hidden' : '')};
`;

export const DeclineSpinner = styled.span`
  min-width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: ${gridSize() / 2}px;
`;
